import { render, staticRenderFns } from "./allCollectes.vue?vue&type=template&id=bcc4f5ea&scoped=true"
import script from "./allCollectes.vue?vue&type=script&lang=js"
export * from "./allCollectes.vue?vue&type=script&lang=js"
import style0 from "./allCollectes.vue?vue&type=style&index=0&id=bcc4f5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc4f5ea",
  null
  
)

export default component.exports